module.exports = __webpack_public_path__ + "static/media/saif.ae1de32e.jpg";